import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { APP_CONFIG } from "../config/appConfig";

// --- 전화번호 유틸 ---

/** 한국 번호 → E.164 (+82...) */
export function toE164KR(raw) {
  const n = raw.replace(/[^0-9]/g, "");
  if (n.startsWith("0")) return "+82" + n.slice(1);
  if (n.startsWith("82")) return "+" + n;
  return "+82" + n;
}

/** E.164 → 한국 표시형 (010-1234-5678) */
export function formatKRPhone(e164) {
  if (!e164) return "";
  const local = e164.replace(/^\+82/, "0");
  if (local.length === 11) return `${local.slice(0, 3)}-${local.slice(3, 7)}-${local.slice(7)}`;
  if (local.length === 10) return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`;
  return local;
}

/** 5자리 OTP 생성 (이름은 호환 위해 genOtp6 유지) */
export function genOtp6() {
  return String(Math.floor(10000 + Math.random() * 90000));
}

// --- SMS 프록시 ---

/** Cloud Function을 통해 OTP SMS 발송 */
export async function sendOtpViaProxy({ phone, authcode }) {
  const cfUrl = APP_CONFIG.sms.cfUrl;
  if (!cfUrl) throw new Error("SMS 서비스가 설정되지 않았습니다.");

  const normalized = phone.replace(/[^0-9]/g, "");
  const res = await fetch(cfUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone: normalized, authcode, label: APP_CONFIG.sms.label }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "SMS 발송 실패");
  return data;
}

// --- 찾기 서비스 ---

/** 전화번호(E164)로 이메일 찾기 — users_by_phone 인덱스 조회 */
export async function findEmailByPhoneE164(phoneE164) {
  const ref = doc(db, "users_by_phone", phoneE164);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  const { uid } = snap.data();
  if (!uid) return null;

  const userRef = doc(db, "users", uid);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) return null;
  const userData = userSnap.data();
  return userData.email || userData.loginId || null;
}

/** 전화번호(E164)로 UID 찾기 */
export async function findUidByPhoneE164(phoneE164) {
  const ref = doc(db, "users_by_phone", phoneE164);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return snap.data().uid || null;
}

// --- 비밀번호 리셋 ---

/** Cloud Function 프록시를 통한 비밀번호 변경 */
export async function resetPasswordViaProxy({ uid, newPassword }) {
  const cfUrl = APP_CONFIG.resetPasswordUrl;
  if (!cfUrl) throw new Error("비밀번호 리셋 서비스가 설정되지 않았습니다.");

  const res = await fetch(cfUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, newPassword }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "비밀번호 변경 실패");
  return data;
}

// --- 마스킹 ---

/** 이메일 마스킹: abc@gmail.com → a**@gmail.com */
export function maskEmail(email) {
  if (!email) return "";
  const [local, domain] = email.split("@");
  if (!domain) return email;
  if (local.length <= 1) return `${local}***@${domain}`;
  return `${local[0]}${"*".repeat(Math.min(local.length - 1, 5))}@${domain}`;
}
